export const ALLOW_PASI_UPDATES = true;